import React, { useEffect, useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { getGameImages } from '../../../core/helpers/getGameImages';
import { isMobile } from '../../../core/helpers/isMobile';

const GameMainBackground = observer(({ bgConfig }) => {
  const ref = useRef();
  const { background } = useMemo(() => {
    return getGameImages();
  }, []);

  useEffect(() => {
    if (ref.current && isMobile()) {
      ref.current.width = window.innerWidth;
      ref.current.height = window.innerHeight;
    }
  }, []);

  return (
    <Container {...bgConfig} name='mainBackground'>
      <Sprite texture={background} ref={ref} />
    </Container>
  );
});
export default GameMainBackground;
